// extracted by mini-css-extract-plugin
export default {"sidebarContainer":"Sidebar_sidebarContainer__MP20Z"};